import React from "react";
import PropTypes from "prop-types";
import {
  ChartCategoryAxis,
  ChartCategoryAxisItem,
} from "@progress/kendo-react-charts";

/**
 * ChartCategoryAxisComponent
 * @class
 * @property {object} categoryAxisItemProps - Props of module ChartCategoryAxisItem
 */

/**
 * ChartCategoryAxis
 * @module
 */

/**
 * ChartCategoryAxisItem
 * @module
 * @property {array} categories - Categories
 * @property {object} title - Title
 * @property {array} axisCrossingValues - Positions axises in chart
 * @property {number} maxDivisions - Display max divisions on X axis
 */

const ChartCategoryAxisComponent = (props) => {
  const { categoryAxisItemProps } = props;
  return (
    <ChartCategoryAxis>
      <ChartCategoryAxisItem
        categories={categoryAxisItemProps.categories}
        title={categoryAxisItemProps.title}
        axisCrossingValues={categoryAxisItemProps.axisCrossingValues}
        maxDivisions={categoryAxisItemProps.maxDivisions}
      />
    </ChartCategoryAxis>
  );
};

ChartCategoryAxisComponent.propTypes = {
  categoryAxisItemProps: PropTypes.shape({
    categories: PropTypes.array,
    title: PropTypes.object,
    axisCrossingValues: PropTypes.array,
    maxDivisions: PropTypes.number,
  }),
};

export default ChartCategoryAxisComponent;
